import {decodeJwtPayload} from './decodeJwtPayload';
import {fetchCurrentUser} from './fetchCurrentUser';

export const currentUserQueryRootKey = ['currentUser'] as const;

export function createCurrentUserQueryOptions(accessToken: string) {
  const strapiUserId =
    decodeJwtPayload<{strapiUserId?: string}>(accessToken)?.strapiUserId
    ?? null;

  // Keyed by user id, not by token: a silent token refresh must not create
  // a new cache entry, otherwise `isLoading` flips back to true and the
  // protected layout unmounts the current page (losing unsaved form input).
  return {
    queryFn: () => fetchCurrentUser(accessToken),
    queryKey: [...currentUserQueryRootKey, strapiUserId],
  };
}
